import { routes } from '../routes';
import { ajax } from 'rxjs/ajax';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
export const technical = (clientConfig) => {
    const { baseUrl, headers } = clientConfig;
    const route = routes(baseUrl).GET_VEHICLE_TECHNICAL;
    /**
     * Function to fetch the details of the vehicle based on id.
     * @param {string} id of the vehicle.
     */
    const getVehicleTechnical = (id) => ajax.get(route(id), headers).pipe(map((r) => r.response), catchError((error) => {
        return of(error);
    }));
    return { getVehicleTechnical };
};
